import { useEffect, useState } from 'react';
import { useMediaQuery } from '@sauda/ui/kit';

export { useMediaQuery } from '@sauda/ui/kit';

/** The window classes of the design system (03-design-system.md): compact, medium, expanded, large. */
export type WindowClass = 'compact' | 'medium' | 'expanded' | 'large';

/** The class for a width in pixels. */
export function windowClassFor(width: number): WindowClass {
  return width < 600 ? 'compact' : width < 840 ? 'medium' : width < 1200 ? 'expanded' : 'large';
}

/** The current window class. It follows the window live, so a resize or a rotation re-lays the app out. */
export function useWindowClass(): WindowClass {
  const medium = useMediaQuery('(min-width: 600px)');
  const expanded = useMediaQuery('(min-width: 840px)');
  const large = useMediaQuery('(min-width: 1200px)');
  return large ? 'large' : expanded ? 'expanded' : medium ? 'medium' : 'compact';
}

/** Follows the browser's online state, for the offline banner. */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() => navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}
